/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown>, total: NonNullable<unknown>, peak: NonNullable<unknown>, peakDate: NonNullable<unknown> }} Chartsummary1Inputs */

const en_chartsummary1 = /** @type {(inputs: Chartsummary1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.first} to ${i?.last}: ${i?.total} in total, peak ${i?.peak} (${i?.peakDate}).`)
};

const de_chartsummary1 = /** @type {(inputs: Chartsummary1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.first} bis ${i?.last}: insgesamt ${i?.total}, Höchstwert ${i?.peak} (${i?.peakDate}).`)
};

/**
* | output |
* | --- |
* | "From {first} to {last}: {total} in total, peak {peak} ({peakDate})." |
*
* @param {Chartsummary1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartsummary1 = /** @type {((inputs: Chartsummary1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartsummary1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartsummary1(inputs)
	return de_chartsummary1(inputs)
});
export { chartsummary1 as "chartSummary" }